export default "__VITE_ASSET__DqY5LcVx__"